var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"product-section"},[_c('h3',{staticClass:"section-title section-title--white"},[_vm._v(" Designed & Developed by Us ")]),_c('div',{staticClass:"product-section__card-container container-fluid"},_vm._l((_vm.cards),function(ref,index){
var link = ref.link;
var category = ref.category;
var title = ref.title;
var text = ref.text;
var technologies = ref.technologies;
return _c('ProductCard',{key:index,staticClass:"product-section__card",attrs:{"link":link,"category":category,"title":title,"text":text,"technologies":technologies}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }